// extracted by mini-css-extract-plugin
module.exports = {"containerWidth":"Feedback_containerWidth__1SUpK"};